import {
  TDLV_LIST, TDLV_LIST_SUCCESS, TDLV_LIST_ERROR, TDLV_PAGE_SET,
  TDLV_ADD, TDLV_ADD_SUCCESS, TDLV_ADD_ERROR,
  TDLV_SEARCH_CHANGE,
  TDLV_FILTER_TASK_STATUS_SUCCESS,
  TDLV_FILTER_SUPPLIERS_SUCCESS,
  TDLV_FILTER_DESTINATIONS_SUCCESS
} from '../../actions';

const INIT_STATE = {
  loading: true,
  list: { header: { name: 'idx', order: 'sorted-asc' }, page: { current: 1, rows: 1000 }, data: [], total_pages: 1 },
  add: { loading: false, response: '' },
  search: { data: { supplier: '', task_status: '', delivery_date: '', destination: '' } },
  filters: { task_status: [], suppliers: [], destinations: [] },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case TDLV_LIST: return { ...state, loading: true };
    case TDLV_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case TDLV_LIST_ERROR: return { ...state, loading: false, error: true };
    case TDLV_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
    case TDLV_ADD: return { ...state, add: { loading: true, response: '' } };
    case TDLV_ADD_SUCCESS: return { ...state, add: { loading: false, response: 'success' } };
    case TDLV_ADD_ERROR: return { ...state, add: { loading: false, response: 'error' } };
    case TDLV_SEARCH_CHANGE: return { ...state, search: { ...state.search, data: action.payload } };
    case TDLV_FILTER_TASK_STATUS_SUCCESS: return { ...state, filters: { ...state.filters, task_status: action.payload } };
    case TDLV_FILTER_SUPPLIERS_SUCCESS: return { ...state, filters: { ...state.filters, suppliers: action.payload } };
    case TDLV_FILTER_DESTINATIONS_SUCCESS: return { ...state, filters: { ...state.filters, destinations: action.payload } };
    default: return { ...state };
  }
};
